import React, { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { countriesData } from "../../countriesData.js";
import NextButton from "../common/NextButton/NextButton";
import axios from "axios";
import { dataContext, authContext } from "../context/context";
import { withStyles } from "@material-ui/core/styles";
import {
  FormControlLabel,
  Radio,
  RadioGroup,
  FormControl,
} from "@material-ui/core";
import { getFunctions, httpsCallable } from "firebase/functions";
import { useMediaQuery } from "react-responsive";
import { updateLatestActions } from "../../utils";
import {
  query,
  collection,
  db,
  where,
  getDocs,
  getDoc,
  Timestamp,
  doc,
  updateDoc,
} from "../../firebase/firebaseApp";
import NoPoverty from "../../assets/SDG/E-WEB-Goal-01.png";
import ZeroHunger from "../../assets/SDG/E-WEB-Goal-02.png";
import GoodHealth from "../../assets/SDG/E-WEB-Goal-03.png";
import QualityEducation from "../../assets/SDG/E-WEB-Goal-04.png";
import GenderEquality from "../../assets/SDG/E-WEB-Goal-05.png";
import CleanWater from "../../assets/SDG/E-WEB-Goal-06.png";
import CleanEnergy from "../../assets/SDG/E-WEB-Goal-07.png";
import DecentWork from "../../assets/SDG/E-WEB-Goal-08.png";
import Innovation from "../../assets/SDG/E-WEB-Goal-09.png";
import ReducedInequalities from "../../assets/SDG/E-WEB-Goal-10.png";
import SustainableCities from "../../assets/SDG/E-WEB-Goal-11.png";
import ResponsibleConsumption from "../../assets/SDG/E-WEB-Goal-12.png";
import ClimateAction from "../../assets/SDG/E-WEB-Goal-13.png";
import LifeBelowWater from "../../assets/SDG/E-WEB-Goal-14.png";
import LifeOnLand from "../../assets/SDG/E-WEB-Goal-15.png";
import Peace from "../../assets/SDG/E-WEB-Goal-16.png";
import Partnerships from "../../assets/SDG/E-WEB-Goal-17.png";
import SDG from "../../assets/SDG/SDGs-transparent.png";
import { storage } from "../../firebase/firebaseApp";
import { countryList } from "../../countries.js";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import {
  ImageGridItem,
  Bullet,
  Modal,
  TextButton,
  PrairiButton,
  DeckPrompt,
  UnicornNote,
  Loading,
} from "@peterfosso/prairi-components";
import { CountryDropdown } from "react-country-region-selector";
import Switch from "react-switch";
import CompanyLogo from "../../assets/company2.png";
import PitchLogo from "../../assets/pitch.png";
import Clock from "../../assets/clock4.png";
import PrairiWhiteLogo from "../../assets/prairiwhite.png";
import Invitation from "../Invitation";
import DeckApproval from "../DeckApproval";
const Company = (props) => {
  const { setDataFunc, globalData } = useContext(dataContext);
  const companyData = globalData.formData.company;
  const { currentUser } = useContext(authContext);
  const [showGoals, setShowGoals] = useState(false);
  const [fileName, setFileName] = useState("");
  const [uploadingDeck, setUploadingDeck] = useState(false);
  const [pitchFile, setPitchFile] = useState(null);
  const [pitchProgress, setPitchProgress] = useState("");
  const [pdfUrl, setPdfUrl] = useState("");
  const [updatePending, setUpdatePending] = useState(false);
  const [thankyouNote, setThankyouNote] = useState(false);
  const [showGoalsPopup, setShowgoalsPopup] = useState(
    companyData.goals && companyData.goals.length > 0 && companyData.goals
  );
  const [isLoading, setIsLoading] = useState(true);

  const isMobile = useMediaQuery({ maxWidth: 767 });
  const handleGoalsBoolean = (event) => {
    setData({
      ...data,
      goalsBool: event.target.value,
    });
  };

  const goalsHandler = (value) => {
    setData({
      ...data,
      goals: goals.includes(value)
        ? goals.filter((goal) => goal !== value)
        : [...goals, value],
    });
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    setPitchFile(file);
    const truncatedName =
      file.name.length > 20 ? file.name.substring(0, 20) + "..." : file.name;
    setFileName(truncatedName.length > 0 ? truncatedName : "");
    setDeckError("");
    setPitchDeck(null); // Reset pitchDeck when new file is selected

    // Automatically upload the file with a small timeout
    if (file) {
      setTimeout(async () => {
        try {
          const pdfUrl = await handleUploadWithFile(file);
          setPitchDeck(pdfUrl);
          setUploadingDeck(false);
          setThankyouNote(true);
          
          // Automatically save the deck URL to the user's profile
          if (docId) {
            try {
              let userRef = doc(db, "users", docId);
              await updateDoc(userRef, {
                "formData.company.deck": pdfUrl,
              });
              console.log("Deck URL saved to user profile successfully");
            } catch (error) {
              console.log("Error saving deck URL to user profile:", error);
            }
          }
        } catch (error) {
          console.log(error);
          setUploadingDeck(false);
          setDeckError("Upload failed. Please try again.");
        }
      }, 500); // 500ms timeout
    }
  };

  const WhiteRadio = withStyles({
    root: {
      color: "#ffffff", // Color del radio button cuando no está seleccionado
      "&$checked": {
        color: "#92d050", // Color del radio button cuando está seleccionado (verde Prairi)
      },
      "&:hover": {
        color: "#92d050", // Color al hacer hover
      },
    },
    checked: {},
  })((props) => <Radio color="default" {...props} />);

  useEffect(() => {
    if (goalsBool === "Yes") {
      setShowgoalsPopup(true);
    }
  }, [showGoals]);
  const [limitMessage, setLimitMessage] = useState(null);
  const [deckError, setDeckError] = useState("");
  const [pitchUpdatePopup, setPitchUpdatePopup] = useState(false);
  const [docId, setDocId] = useState(null);
  const [location, setLocation] = useState({});
  const [detectedCountry, setDetectedCountry] = useState("");
  const [currentUserData, setCurrentUserData] = useState(null);
  const [pendingDeck, setPendingDeck] = useState(false);
  const [outsideDeck, setOutsideDeck] = useState(false);
  const [fetchedData, setFetchedData] = useState(false);
  const [pitchDeck, setPitchDeck] = useState(null);
  useEffect(() => {
    const fetchLocation = async () => {
      try {
        const response = await axios.get(
          "https://ipinfo.io/json?token=00b36ccb7a5f35"
        );
        const countryCode = response.data.country.toLowerCase();
        setLocation(countryCode);

        // Asegúrate de que countriesData tenga un formato como { code: "CL", name: "Chile" }
        const detectedCountry =
          countriesData.find(
            (country) => country.code.toLowerCase() === countryCode
          )?.name || ""; // Si no encuentra el país, se quedará con una cadena vacía

        setDetectedCountry(detectedCountry);
      } catch (error) {
        console.error("Error fetching location:", error);
      }
    };

    fetchLocation();
  }, []);
  // Empty dependency array to ensure the effect runs only once on component mount

  const [data, setData] = useState({
    company: companyData.company || "",
    country: companyData.country || detectedCountry,
    state: "",
    date: companyData.date || "",
    slogan: companyData.slogan || "",
    deck: companyData.deck || "",
    url: companyData.url || globalData.url || "",
    pitch: companyData.pitch || "",
    videoPitch: companyData.videoPitch || "",
    investorButton: companyData.investorButton || "",
    generatedFields: companyData.generatedFields || "",
    goals: companyData.goals || [],
    goalsBool: companyData.goalsBool || false,
    error: "",
    loading: false,
    message: "",
  });
  const deckPattern =
    /^https:\/\/firebasestorage\.googleapis\.com\/v0\/b\/prairi-prod-fe3a4\.appspot\.com\/.*/;
  const testUrl = (url) => deckPattern.test(url);

  // Function to extract filename from Firebase Storage URL
  const getFilenameFromUrl = (url) => {
    if (!url) return "";
    try {
      // Extract the filename from the URL path
      const urlObj = new URL(url);
      const pathParts = urlObj.pathname.split("/");
      const filename = pathParts[pathParts.length - 1];
      // Decode the URL-encoded filename
      return decodeURIComponent(filename).split("/")[1];
    } catch (error) {
      console.error("Error parsing URL:", error);
      return "";
    }
  };
  let navigate = useNavigate();
  const usStates = [
    "Alabama",
    "Alaska",
    "Arizona",
    "Arkansas",
    "California",
    "Colorado",
    "Connecticut",
    "Delaware",
    "Florida",
    "Georgia",
    "Hawaii",
    "Idaho",
    "Illinois",
    "Indiana",
    "Iowa",
    "Kansas",
    "Kentucky",
    "Louisiana",
    "Maine",
    "Maryland",
    "Massachusetts",
    "Michigan",
    "Minnesota",
    "Mississippi",
    "Missouri",
    "Montana",
    "Nebraska",
    "Nevada",
    "New Hampshire",
    "New Jersey",
    "New Mexico",
    "New York",
    "North Carolina",
    "North Dakota",
    "Ohio",
    "Oklahoma",
    "Oregon",
    "Pennsylvania",
    "Rhode Island",
    "South Carolina",
    "South Dakota",
    "Tennessee",
    "Texas",
    "Utah",
    "Vermont",
    "Virginia",
    "Washington",
    "West Virginia",
    "Wisconsin",
    "Wyoming",
  ];

  const getDataFromDb = async () => {
    try {
      // Get user data from email
      const { email } = currentUser;
      const q = query(collection(db, "users"), where("email", "==", email));
      const querySnapshot = await getDocs(q);
      let userData;
      let userId;
      querySnapshot.forEach((doc) => {
        userData = doc.data();
        userId = doc.id;
        setCurrentUserData(doc.data());
        if (!doc.data().formData?.company?.deck && doc.data().pitchdeck) {
          companyData.deck = doc.data().pitchdeck;
          if (!testUrl(deck)) {
            setOutsideDeck(true);
          }
          setData((prevState) => ({
            ...prevState,
            deck: doc.data().pitchdeck,
          }));
        }
        if (doc.data().url && !doc.data().formData) {
          companyData.url = doc.data().url;
          setData((prevState) => ({
            ...prevState,
            url: doc.data().url,
          }));
        }
        if (doc.data().country && !doc.data().formData) {
          setData((prevState) => ({
            ...prevState,
            country: doc.data().country,
          }));
        }
        if (!doc.data().country && !doc.data().formData) {
          setData((prevState) => ({
            ...prevState,
            country: detectedCountry,
          }));
        }
      });
      setFetchedData(true);
      return { userData, userId };
    } catch (error) {
      //  console.log(error);
    }
  };

  const handleChange = (e) => {
    if (e.target.name === "pitch" && e.target.value.length >= 500) {
      setLimitMessage("Your pitch must be 500 characters or less.");
    } else {
      setLimitMessage(null);
    }
    setData({ ...data, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    const getUpdatedData = () => {
      setData((prevData) => ({ ...prevData, ...companyData }));
    };
    getUpdatedData();
  }, [companyData]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (currentUser) {
      const fetchData = async () => {
        setIsLoading(true);
        const { userData, userId } = await getDataFromDb();
        setDocId(userId);
        setCurrentUserData(userData);
        setIsLoading(false);
      };
      fetchData();
    }
  }, [currentUser]);

  const addField = (groupName) => {
    // all fields
    const allFields = generatedFields[groupName];
    const newFieldName = `field${allFields.length}`;
    const newField = { fieldName: newFieldName, fieldValue: "" };
    allFields.push(newField);
    setData({
      ...data,
      generatedFields: {
        ...data.generatedFields,
        [groupName]: [...allFields],
      },
    });
  };

  const handleDynamicInput = (e, groupName, index) => {
    const allFields = generatedFields[groupName];
    allFields[index].fieldValue = e.target.value;
    setData({
      ...data,
      generatedFields: {
        ...data.generatedFields,
        [groupName]: [...allFields],
      },
    });
  };
  const closeField = (groupName, index) => {
    const allFields = generatedFields[groupName];
    allFields.splice(index, 1);
    setData({
      ...data,
      generatedFields: {
        ...data.generatedFields,
        [groupName]: [...allFields],
      },
    });
  };

  const handleUpload = () => {
    return new Promise((resolve, reject) => {
      if (!pitchFile) {
        setDeckError("No file selected");
        reject("No file selected");
        return;
      }

      setUploadingDeck(true);
      const storageRef = ref(storage, `pdfs/${pitchFile.name}`);
      const uploadTask = uploadBytesResumable(storageRef, pitchFile);

      uploadTask.on(
        "state_changed",
        (snapshot) => {
          const progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          setPitchProgress(progress);
        },
        (error) => {
          console.error("Upload failed:", error);
          reject(error);
        },
        () => {
          getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
            setPdfUrl(downloadURL);
            resolve(downloadURL);
          });
        }
      );
    });
  };

  const handleUploadWithFile = (file) => {
    return new Promise((resolve, reject) => {
      if (!file) {
        setDeckError("No file selected");
        reject("No file selected");
        return;
      }

      setUploadingDeck(true);
      const storageRef = ref(storage, `pdfs/${file.name}`);
      const uploadTask = uploadBytesResumable(storageRef, file);

      uploadTask.on(
        "state_changed",
        (snapshot) => {
          const progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          setPitchProgress(progress);
        },
        (error) => {
          console.error("Upload failed:", error);
          reject(error);
        },
        () => {
          getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
            setPdfUrl(downloadURL);
            resolve(downloadURL);
          });
        }
      );
    });
  };

  const deleteDeck = () => {
    if (fileName) {
      // If fileName exists, reset everything to empty
      setPitchFile(null);
      setFileName("");
      setPitchDeck(null);
      setPdfUrl("");
      setDeckError("");
      setUploadingDeck(false);
      setPitchProgress("");
    } else {
      // If no fileName, remove deck from local data
      setData({
        ...data,
        deck: "",
      });
    }
    // Always reset deck to empty to hide the "Choose file" button
    setData({
      ...data,
      deck: "",
    });
  };

  const handleSubmitDeck = async () => {
    try {
      let userRef = doc(db, "users", docId);
      const pdfUrl = await handleUpload();
      setPitchDeck(pdfUrl);
      setUploadingDeck(false);
    } catch (error) {
      console.log(error);
    }
  };

  const handleUploadDeck = async () => {
    try {
      setUploadingDeck(true);
      const pdfUrl = await handleUpload();
      setPitchDeck(pdfUrl);
      setUploadingDeck(false);
      setThankyouNote(true);
    } catch (error) {
      console.log(error);
      setUploadingDeck(false);
      setDeckError("Upload failed. Please try again.");
    }
  };

  const handleSubmit = (e, finish = false) => {
    e.preventDefault();
    const companyName = company.trim();
    const companyCountry = country.trim();
    const companySlogan = slogan.trim();
    const companyPitch = pitch.trim();
    const companyVideoPitch = videoPitch.trim();
    const companyState = state.trim();
    const companyDeck = deck.trim();
    const time = Timestamp.fromDate(new Date());
    const latestTime = time
      .toDate()
      .toLocaleDateString("en-US", { month: "2-digit", day: "2-digit" });
    if (
      !companyName ||
      !companyCountry ||
      !companySlogan ||
      !companyPitch ||
      !(companyDeck || pitchDeck || globalData.pitchdeck) ||
      (companyCountry === "United States" && !companyState)
    ) {
      setData({ ...data, error: "Fill all the required fields." });
    } else {
      setData({
        ...data,
        error: "",
        loading: true,
        message: "Saving... (click progress bar if you wish to edit)",
      });

      setTimeout(async () => {
        // Update database with pitch deck if it was uploaded
        if (pitchDeck && docId) {
          try {
            let userRef = doc(db, "users", docId);
            await updateDoc(userRef, {
              "formData.company.deck": pitchDeck,
            });
          } catch (error) {
            console.log("Error updating deck in database:", error);
          }
        }

        setDataFunc({
          ...globalData,
          formData: {
            ...globalData.formData,
            company: {
              ...companyData,
              company: companyName,
              country: companyCountry,
              state: companyState,
              slogan,
              deck: pitchDeck || deck,
              pitch,
              url,
              videoPitch,
              generatedFields,
              investorButton,
              goals,
              goalsBool,
              completed: true,
            },
          },
        });

        let ref = doc(db, "users", docId);
        updateLatestActions(ref, "Saved company form", isMobile);
        if (finish) {
          navigate("/startupregistration/matching");
        } else {
          navigate("/startupregistration/industry");
        }
      }, 2000);
    }
  };

  const {
    company,
    country,
    state,
    date,
    videoPitch,
    slogan,
    deck,
    url,
    pendingApproval,
    pitch,
    generatedFields,
    investorButton,
    message,
    error,
    goals,
    goalsBool,
  } = data;

  useEffect(() => {
    if (
      company !== "" &&
      url !== "" &&
      country !== "" &&
      slogan !== "" &&
      pitch !== ""
    ) {
      setData((prevData) => ({
        ...prevData,
        error: false,
      }));
    }
  }, [company, url, country, slogan, pitch]);

  if (isLoading) {
    return (
      <div
        className="flex justify-center items-center pb-[350px]"
        style={{ marginTop: "100px" }}
      >
        <Loading />
      </div>
    );
  }

  return (
    <div className=" shadow-black w-[90%] rounded-md mt-2 md:max-w-xl mx-auto py-2.5   ">
      <form className=" " onSubmit={(e) => handleSubmit(e, false)}>
        <div className="my-2 ">
          {!currentUserData?.formData && fetchedData && (
            <div className="relative mb-8">
              {/* Prairi Logo positioned absolutely to align with form icons */}
              <div className="absolute left-3 md:left-0 top-0 h-14 flex items-center justify-center mr-2 md:mr-4">
                <img
                  alt="Prairi Logo"
                  src={PrairiWhiteLogo}
                  className="h-full w-auto"
                />
              </div>

              {/* Centered text content */}
              <div className="flex flex-col justify-center pl-8 text-center w-full">
                <p className="mb-2 text-2xl text-white leading-none font-light">
                  To match with <span className="font-bold">investors</span>
                </p>
                <p className="mb-2 text-2xl text-white leading-none font-light">
                  you'll now create your Data Profile
                </p>

                <div className="flex justify-center pr-8 items-center mt-2">
                  <img
                    alt="Clock"
                    src={Clock}
                    className="w-[50px] pr-4 brightness-50"
                  />
                  <div className="text-yellowPrairi text-md">
                    Only takes about 5 minutes
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className="flex items-end pl-3 md:pl-0">
            <div
              className={` h-10 md:h-12 flex items-center justify-center mr-2 md:mr-4 `}
            >
              <img className=" h-full  " src={CompanyLogo} alt="Company" />
            </div>
            <h1 className=" text-base  md:text-xl text-white uppercase font-bold">
              Company
            </h1>
          </div>
          <div className="mt-5 px-3 md:pl-24">
            <label htmlFor="company">Company Name</label>
            <input
              className="border-blackish mt-2.5 w-full rounded border p-2.5 text-black outline-none"
              type="text"
              name="company"
              id="company"
              placeholder="Enter Company's name"
              value={company}
              onChange={handleChange}
            ></input>
          </div>
          <div className="mt-5 px-3 md:pl-24">
            <label htmlFor="url">Company URL (Website)</label>
            <input
              className="border-blackish mt-2.5 w-full rounded border p-2.5 text-black outline-none"
              type="text"
              name="url"
              id="url"
              placeholder="Enter Company's website"
              value={url}
              onChange={handleChange}
            ></input>
          </div>

          <div className="mt-5 px-3 md:pl-24">
            <label htmlFor="country">Company Location</label>
            <select
              className="border-blackish mt-2.5 w-full rounded border p-2.5 text-black outline-none"
              value={country}
              onChange={handleChange}
              name="country"
              id="country"
            >
              <option value="">Select a country</option>
              {countryList.map((option, index) => (
                <option key={option.value}>{option}</option>
              ))}
            </select>
          </div>
          {country === "United States" && (
            <div className="mt-5 px-3 md:pl-24">
              <label htmlFor="country">State</label>
              <select
                className="border-blackish mt-2.5 w-full rounded border p-2.5 text-black outline-none"
                value={state}
                onChange={handleChange}
                name="state"
                id="state"
              >
                <option value="">Select a state</option>
                {usStates.map((option, index) => (
                  <option key={option.value}>{option}</option>
                ))}
              </select>
            </div>
          )}
        </div>
        <div className="my-5 ">
          <div className="flex items-end pl-3 md:pl-0">
            <div
              className={` h-10 md:h-12 flex items-center justify-center mr-2 md:mr-4 `}
            >
              <img className=" h-full  " src={PitchLogo} alt="Company" />
            </div>
            <h1 className=" text-base  md:text-xl text-white uppercase font-bold">
              Pitch
            </h1>
          </div>
          <div className="mt-3 px-3 md:pl-24">
            <label htmlFor="slogan">Slogan</label>
            <input
              className="border-blackish mt-2.5 w-full rounded border p-2.5 text-black outline-none"
              type="text"
              name="slogan"
              id="slogan"
              placeholder="Your one-liner"
              value={slogan}
              onChange={handleChange}
            ></input>
          </div>
          <div className="mt-5 px-3 md:pl-24">
            <label htmlFor="pitch">Pitch summary</label>
            <textarea
              className="border-blackish mt-2.5 w-full rounded border p-2.5 text-black outline-none"
              name="pitch"
              id="pitch"
              placeholder="Elevator pitch: Make sure to include the problem you are solving, how you will solve it, and how you will grow, etc"
              value={pitch}
              onChange={handleChange}
              rows="3"
              maxLength={500}
            ></textarea>
            {limitMessage && <p className="text-redPrairi">{limitMessage}</p>}
          </div>

          <div className="mt-5 px-3 md:pl-24">
            <div>
              <label htmlFor="deck">Pitch deck (.pdf)</label>
              
              {/* Show input field with X button when fileName is not empty OR when there's formData with existing deck */}
              {(fileName !== "" || (currentUserData?.formData && deck)) && (
                <div className="flex items-center">
                  <input
                    className="border-blackish mt-2.5 w-full bg-silverPrairi rounded border p-2.5 text-lighterGray outline-none"
                    type="text"
                    value={fileName !== "" ? fileName : (deck ? getFilenameFromUrl(deck) : "")}
                  ></input>
                  <button
                    type="button"
                    className="uppercase bg-navBg cursor-pointer rounded border border-gray-500 flex row items-center justify-center w-10 h-10 text-base text-white outline-none transition-all duration-300 ease-in-out hover:scale-105 mt-2.5"
                    onClick={deleteDeck}
                  >
                    x
                  </button>
                </div>
              )}

              {/* Show Choose file button when fileName is empty AND no existing deck */}
              {fileName === "" && !(currentUserData?.formData && deck) && (
                <div>
                  <input
                    type="file"
                    name="pitchdeck"
                    id="pitchdeck"
                    accept="application/pdf"
                    onChange={handleFileChange}
                    className="hidden"
                  />
                  <div className="mt-2">
                    <label
                      htmlFor="pitchdeck"
                      className="border-blackish mt-2.5 w-full rounded border p-2.5 text-black outline-none cursor-pointer bg-gray-100 transition-colors duration-200 block"
                    >
                      Choose file
                    </label>
                  </div>


                </div>
              )}
                                <p className=" italic text-greenPrairi truncate ">
                    {uploadingDeck && <>Uploading...</>}
                    {pdfUrl !== "" && <>Successfully uploaded!</>}
                    {!uploadingDeck && !pitchDeck && fileName !== "" && (
                      <p className="text-yellowPrairi">File selected</p>
                    )}
                  </p>
                  {deckError && (
                    <p className="text-redPrairi text-sm mt-2">{deckError}</p>
                  )}
            </div>

          </div>

          <div className="mt-5 px-3 md:pl-24">
            <label htmlFor="slogan">
              Link to a <span className="font-bold">video</span> pitch
              [optional]
            </label>
            <input
              className="border-blackish mt-2.5 w-full rounded border p-2.5 text-black outline-none"
              type="text"
              name="videoPitch"
              id="videoPitch"
              placeholder=""
              value={videoPitch}
              onChange={handleChange}
            ></input>
          </div>

          <div className="mt-5 px-3 md:pl-24">
            <div className="flex justify-between items-center my-2 ">
              <h1 className="mr-4">
                Company's social media profiles [optional]
              </h1>
            </div>
            {/* dynamic fields */}
            {generatedFields.profile.map((field, index) => {
              return (
                <div
                  key={field.fieldName}
                  className="flex justify-between items-center "
                >
                  <input
                    className="border-blackish my-2.5 w-10/12  rounded border p-2.5 text-black outline-none"
                    type="text"
                    name={field.fieldName}
                    id={field.fieldName}
                    placeholder={`https://www.profile${index + 1}.com/username`}
                    value={field.fieldValue}
                    onChange={(e) => handleDynamicInput(e, "profile", index)}
                  ></input>
                  {index === 0 && (
                    <input
                      type="button"
                      className="  uppercase bg-navBg cursor-pointer rounded border border-gray-500 flex items-center justify-center w-10 h-10  text-base text-white outline-none transition-all duration-300 ease-in-out hover:scale-105 "
                      value="+"
                      onClick={() => addField("profile")}
                    ></input>
                  )}
                  {index > 0 && (
                    <input
                      type="button"
                      className="  uppercase bg-navBg cursor-pointer rounded border border-gray-500 flex items-center justify-center w-10 h-10 text-base  text-white outline-none transition-all duration-300 ease-in-out hover:scale-105 "
                      value="-"
                      onClick={() => closeField("profile", index)}
                    ></input>
                  )}
                </div>
              );
            })}
          </div>
          <div className="mt-5 px-3 md:pl-24">
            <div className="flex justify-between items-center my-2 ">
              <h1 className="mr-4">
                Other information links, such as press, media, etc. [optional]
              </h1>
            </div>
            {/* dynamic fields */}
            {generatedFields.resource.map((field, index) => {
              return (
                <div
                  key={field.fieldName}
                  className="flex justify-between items-center "
                >
                  <input
                    className="border-blackish my-2.5 w-10/12 mr-auto rounded border p-2 text-black outline-none"
                    type="text"
                    name={field.fieldName}
                    id={field.fieldName}
                    placeholder={`https://www.resource${index + 1}.com`}
                    value={field.fieldValue}
                    onChange={(e) => handleDynamicInput(e, "resource", index)}
                  ></input>
                  {index === 0 && (
                    <input
                      type="button"
                      className="  uppercase bg-navBg cursor-pointer rounded border border-gray-500 flex items-center justify-center w-10 h-10 text-base text-white outline-none transition-all duration-300 ease-in-out hover:scale-105 "
                      value="+"
                      onClick={() => addField("resource")}
                    ></input>
                  )}
                  {index > 0 && (
                    <input
                      type="button"
                      className="  uppercase bg-navBg cursor-pointer rounded border border-gray-500 flex items-center justify-center w-10 h-10 text-base text-white outline-none transition-all duration-300 ease-in-out hover:scale-105 "
                      value="-"
                      onClick={() => closeField("resource", index)}
                    ></input>
                  )}
                </div>
              );
            })}
          </div>

          <div className=" pl-3 md:pl-24 my-4">
            <p>
              Is your startup focused on impacting any specific Sustainable
              Development Goal?
            </p>
            <div className=" flex items-center justify-center ">
              <FormControl component="fieldset">
                <RadioGroup
                  aria-label="goals"
                  name="goals"
                  onChange={handleGoalsBoolean}
                  value={showGoals}
                  row
                >
                  <FormControlLabel
                    sx={{
                      color: "#92d050",
                    }}
                    value="Yes"
                    control={<WhiteRadio checked={goalsBool === "Yes"} />}
                    label={<span className="mr-10">Yes</span>}
                  />
                  <FormControlLabel
                    value="No"
                    control={<WhiteRadio checked={goalsBool === "No"} />}
                    label={<span className="">No</span>}
                  />
                </RadioGroup>
              </FormControl>
            </div>
          </div>
          {goalsBool === "Yes" && (
            <div className=" pl-3 md:pl-24 my-4">
              <p className="mb-2">Select one or more from the following:</p>
              <div className="grid grid-cols-4 grid-rows-5 gap-4">
                <ImageGridItem
                  src={NoPoverty}
                  click={() => goalsHandler("No Poverty")}
                  value="No Poverty"
                  selected={goals.includes("No Poverty")}
                />
                <ImageGridItem
                  src={ZeroHunger}
                  click={() => goalsHandler("Zero Hunger")}
                  value="Zero Hunger"
                  selected={goals.includes("Zero Hunger")}
                />
                <ImageGridItem
                  src={GoodHealth}
                  click={() => goalsHandler("Good Health and Well-being")}
                  value="Good Health and Well-being"
                  selected={goals.includes("Good Health and Well-being")}
                />
                <ImageGridItem
                  src={QualityEducation}
                  click={() => goalsHandler("Quality Education")}
                  value="Quality Education"
                  selected={goals.includes("Quality Education")}
                />
                <ImageGridItem
                  src={GenderEquality}
                  click={() => goalsHandler("Gender Equality")}
                  value="Gender Equality"
                  selected={goals.includes("Gender Equality")}
                />
                <ImageGridItem
                  src={CleanWater}
                  click={() => goalsHandler("Clean Water and Sanitation")}
                  value="Clean Water and Sanitation"
                  selected={goals.includes("Clean Water and Sanitation")}
                />
                <ImageGridItem
                  src={CleanEnergy}
                  click={() => goalsHandler("Affordable and Clean Energy")}
                  value="Affordable and Clean Energy"
                  selected={goals.includes("Affordable and Clean Energy")}
                />
                <ImageGridItem
                  src={DecentWork}
                  click={() => goalsHandler("Decent Work and Economic Growth")}
                  value="Decent Work and Economic Growth"
                  selected={goals.includes("Decent Work and Economic Growth")}
                />
                <ImageGridItem
                  src={Innovation}
                  click={() =>
                    goalsHandler("Industry, Innovation and Infrastructure")
                  }
                  value="Industry, Innovation and Infrastructure"
                  selected={goals.includes(
                    "Industry, Innovation and Infrastructure"
                  )}
                />
                <ImageGridItem
                  src={ReducedInequalities}
                  click={() => goalsHandler("Reduced Inequalities")}
                  value="Reduced Inequalities"
                  selected={goals.includes("Reduced Inequalities")}
                />
                <ImageGridItem
                  src={SustainableCities}
                  click={() =>
                    goalsHandler("Sustainable Cities and Communities")
                  }
                  value="Sustainable Cities and Communities"
                  selected={goals.includes(
                    "Sustainable Cities and Communities"
                  )}
                />
                <ImageGridItem
                  src={ResponsibleConsumption}
                  click={() =>
                    goalsHandler("Responsible Consumption and Production")
                  }
                  value="Responsible Consumption and Production"
                  selected={goals.includes(
                    "Responsible Consumption and Production"
                  )}
                />
                <ImageGridItem
                  src={ClimateAction}
                  click={() => goalsHandler("Climate Action")}
                  value="Climate Action"
                  selected={goals.includes("Climate Action")}
                />
                <ImageGridItem
                  src={LifeBelowWater}
                  click={() => goalsHandler("Life Below Water")}
                  value="Life Below Water"
                  selected={goals.includes("Life Below Water")}
                />
                <ImageGridItem
                  src={LifeOnLand}
                  click={() => goalsHandler("Life on Land")}
                  value="Life on Land"
                  selected={goals.includes("Life on Land")}
                />
                <ImageGridItem
                  src={Peace}
                  click={() =>
                    goalsHandler("Peace, Justice and Strong Institutions")
                  }
                  value="Peace, Justice and Strong Institutions"
                  selected={goals.includes(
                    "Peace, Justice and Strong Institutions"
                  )}
                />
                <ImageGridItem
                  src={Partnerships}
                  click={() => goalsHandler("Partnership for The Goals")}
                  value="Partnership for The Goals"
                  selected={goals.includes("Partnership for The Goals")}
                />

                <img src={SDG} className="col-span-3"></img>
              </div>
            </div>
          )}
        </div>
        <div className="mb-4 mt-8 ">
          <h1 className=" text-base pl-3 md:pl-24 md:text-xl text-white uppercase font-bold">
            Investors
          </h1>
          <div className="mt-5 px-3 md:pl-24 flex items-center">
            <span className="mr-5">Are there existing investors?</span>
            <Switch
              onChange={() =>
                setData({
                  ...data,
                  investorButton: !investorButton,
                })
              }
              checked={investorButton}
              onColor="#92d050"
            />
          </div>
          <div className="mt-5 px-3 md:pl-24">
            <div className="flex justify-between items-center my-2 ">
              <h1>Investor [optional]</h1>
            </div>
            {/* dynamic fields */}
            {generatedFields.investor.map((field, index) => {
              return (
                <div
                  key={field.fieldName}
                  className="flex justify-between items-center "
                >
                  <input
                    className="border-blackish my-2.5 w-10/12 mr-auto rounded border p-2 text-black outline-none"
                    type="text"
                    name={field.fieldName}
                    id={field.fieldName}
                    placeholder={`Investor ${index + 1}`}
                    value={field.fieldValue}
                    onChange={(e) => handleDynamicInput(e, "investor", index)}
                  ></input>
                  {index === 0 && (
                    <input
                      type="button"
                      className="  uppercase bg-navBg cursor-pointer rounded border border-gray-500 flex items-center justify-center w-10 h-10 text-base text-white outline-none transition-all duration-300 ease-in-out hover:scale-105 "
                      value="+"
                      onClick={() => addField("investor")}
                    ></input>
                  )}
                  {index > 0 && (
                    <input
                      type="button"
                      className="  uppercase bg-navBg cursor-pointer rounded border border-gray-500 flex items-center justify-center w-10 h-10 text-base text-white outline-none transition-all duration-300 ease-in-out hover:scale-105 "
                      value="-"
                      onClick={() => closeField("investor", index)}
                    ></input>
                  )}
                </div>
              );
            })}
          </div>
        </div>
        {error && <p className="my-2 px-3 md:pl-24 text-red-500">{error}</p>}
        {message && (
          <p className="my-2 px-3 md:pl-24 text-greenPrairi">
            Saving...{" "}
            <span className="text-silverPrairi">
              (click progress bar if you wish to edit)
            </span>
          </p>
        )}
        <div className="relative flex justify-center my-5 items-end px-3 md:pl-24">
          {currentUserData?.formData?.matching?.completed && (
            <div
              className="absolute right-0 bottom-6 text-silverPrairi underline cursor-pointer"
              onClick={(e) => handleSubmit(e, true)}
            >
              Save & Finish
            </div>
          )}
          <NextButton value="SAVE" />
        </div>
      </form>
    </div>
  );
};

export default Company;
